<template>
  <section class="security-indicators">
    <section-title>SecurityIndicator Component</section-title>
    <form-wrap>
      <form-field-set>
        <text-input
          v-model="password"
          :direction="direction"
          name="password"
          label="Test Password"
        >
          <security-indicator
            slot="addon"
            :percent="percentNumber"
            class="password-indicator"
          />
        </text-input>
      </form-field-set>
    </form-wrap>
  </section>
</template>

<script>
import zxcvbn from 'zxcvbn'
import PlaygroundCommmonMixin from '@/mixins/pages/playground/PlaygroundCommon'
import FormFieldSet from '@/components/forms/FormFieldSet'
import FormWrap from '@/components/forms/FormWrap'
import SectionTitle from '@/components/ui/SectionTitle'
import SecurityIndicator from '@/components/forms/SecurityIndicator'
import TextInput from '@/components/forms/TextInput'

export default {
  name: 'SecurityIndicators',
  mixins: [PlaygroundCommmonMixin],
  components: {
    FormFieldSet,
    FormWrap,
    SectionTitle,
    SecurityIndicator,
    TextInput
  },
  data () {
    return {
      password: ''
    }
  },
  computed: {
    score () {
      return zxcvbn(this.password).score
    },
    percentNumber () {
      return this.score > 0
        ? this.score * 25
        : 0
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/playground/SecurityIndicators.vue